import { render, staticRenderFns } from "./eventodds.vue?vue&type=template&id=c321f166&scoped=true"
import script from "./eventodds.vue?vue&type=script&lang=js"
export * from "./eventodds.vue?vue&type=script&lang=js"
import style0 from "./eventodds.vue?vue&type=style&index=0&id=c321f166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321f166",
  null
  
)

export default component.exports